const toggle = document.querySelector('.theme-toggle')
const root = document.documentElement
const media = window.matchMedia('(prefers-color-scheme: dark)')

const stored = () => {
	try {
		return localStorage.getItem('theme')
	} catch (e) {
		return null
	}
}

const isDark = () => (root.dataset.theme ? root.dataset.theme === 'dark' : media.matches)

const render = () => toggle.setAttribute('aria-checked', String(isDark()))

if (toggle) {
	if (stored()) root.dataset.theme = stored()
	toggle.hidden = false
	render()

	toggle.addEventListener('click', () => {
		const next = isDark() ? 'light' : 'dark'
		root.dataset.theme = next
		try {
			localStorage.setItem('theme', next)
		} catch (e) {}
		render()
	})

	media.addEventListener('change', render)
}
